import * as Dtos from "../dtos/Tmd.dtos";
import { IFormFilter } from "../reducers/index";

export const
    LoadGroupContractByGroupId: IGroupContractLoadByGroupIdActionCreator = (groupId) => {
        return {
            type: ACTION_GROUPCONTRACT_LOAD_BY_GROUP_ID,
            groupId
        }
    },
    LoadGroupContractById: IGroupContractLoadByIdActionCreator = (id) => {
        return {
            type: ACTION_GROUPCONTRACT_LOAD_BY_ID,
            id
        }
    },
    LoadSuccess: IGroupContractLoadSuccessActionCreator = (formData, formState, formProperties, lookups, responseStatus) => {
        return {
            type: ACTION_GROUPCONTRACT_LOAD_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups,
            responseStatus
        }
    },
    LoadFailure: IGroupContractLoadFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_GROUPCONTRACT_LOAD_FAILURE,
            responseStatus
        }
    },

    SaveGroupContract: IGroupContractSaveActionCreator = (formData) => {
        return {
            type: ACTION_GROUPCONTRACT_SAVE,
            formData
        }
    },
    SaveSuccess: IGroupContractSaveSuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_GROUPCONTRACT_SAVE_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    SaveFailure: IGroupContractSaveFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_GROUPCONTRACT_SAVE_FAILURE,
            responseStatus
        }
    },

    ValidateGroupContract: IGroupContractValidateActionCreator = (formData) => {
        return {
            type: ACTION_GROUPCONTRACT_VALIDATE,
            formData
        }
    },
    ValidateSuccess: IGroupContractValidateSuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_GROUPCONTRACT_VALIDATE_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    ValidateFailure: IGroupContractValidateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_GROUPCONTRACT_VALIDATE_FAILURE,
            responseStatus
        }
    },

    CreateGroupContract: IGroupContractCreateActionCreator = (groupId) => {

        return {
            type: ACTION_GROUPCONTRACT_CREATE,
            groupId
        }
    },
    CreateSuccess: IGroupContractCreateSuccessActionCreator = (formData, formState, formProperties, lookups) => {
        return {
            type: ACTION_GROUPCONTRACT_CREATE_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups
        }
    },
    CreateFailure: IGroupContractCreateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_GROUPCONTRACT_CREATE_FAILURE,
            responseStatus
        }
    },

    SyncGroupContract: IGroupContractSyncActionCreator = (groupId) => {

        return {
            type: ACTION_GROUPCONTRACT_SYNC,
            groupId
        }
    },
    SyncSuccess: IGroupContractSyncSuccessActionCreator = (formData, formState, formProperties, lookups, responseStatus) => {
        return {
            type: ACTION_GROUPCONTRACT_SYNC_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups,
            responseStatus
        }
    },
    SyncFailure: IGroupContractSyncFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_GROUPCONTRACT_SYNC_FAILURE,
            responseStatus
        }
    },

    Clear: IGroupContractClearActionCreator = (propertiesToClear?) => {
        return {
            type: ACTION_GROUPCONTRACT_CLEAR,
            propertiesToClear
        }
    },

    Filter: IGroupContractFilterActionCreator = (formFilter) => {
        return {
            type: ACTION_GROUPCONTRACT_FILTER,
            formFilter
        }
    };



export const
    ACTION_GROUPCONTRACT_LOAD_BY_GROUP_ID = "ACTION_GROUPCONTRACT_LOAD_BY_GROUP_ID",
    ACTION_GROUPCONTRACT_LOAD_BY_ID = "ACTION_GROUPCONTRACT_LOAD_BY_ID",
    ACTION_GROUPCONTRACT_LOAD_SUCCESS = "ACTION_GROUPCONTRACT_LOAD_SUCCESS",
    ACTION_GROUPCONTRACT_LOAD_FAILURE = "ACTION_GROUPCONTRACT_LOAD_FAILURE",

    ACTION_GROUPCONTRACT_SAVE = "ACTION_GROUPCONTRACT_SAVE",
    ACTION_GROUPCONTRACT_SAVE_SUCCESS = "ACTION_GROUPCONTRACT_SAVE_SUCCESS",
    ACTION_GROUPCONTRACT_SAVE_FAILURE = "ACTION_GROUPCONTRACT_SAVE_FAILURE",

    ACTION_GROUPCONTRACT_VALIDATE = "ACTION_GROUPCONTRACT_VALIDATE",
    ACTION_GROUPCONTRACT_VALIDATE_SUCCESS = "ACTION_GROUPCONTRACT_VALIDATE_SUCCESS",
    ACTION_GROUPCONTRACT_VALIDATE_FAILURE = "ACTION_GROUPCONTRACT_VALIDATE_FAILURE",

    ACTION_GROUPCONTRACT_CREATE = "ACTION_GROUPCONTRACT_CREATE",
    ACTION_GROUPCONTRACT_CREATE_SUCCESS = "ACTION_GROUPCONTRACT_CREATE_SUCCESS",
    ACTION_GROUPCONTRACT_CREATE_FAILURE = "ACTION_GROUPCONTRACT_CREATE_FAILURE",

    ACTION_GROUPCONTRACT_SYNC = "ACTION_GROUPCONTRACT_SYNC",
    ACTION_GROUPCONTRACT_SYNC_SUCCESS = "ACTION_GROUPCONTRACT_SYNC_SUCCESS",
    ACTION_GROUPCONTRACT_SYNC_FAILURE = "ACTION_GROUPCONTRACT_SYNC_FAILURE",

    ACTION_GROUPCONTRACT_CLEAR = "ACTION_GROUPCONTRACT_CLEAR",

    ACTION_GROUPCONTRACT_FILTER = "ACTION_GROUPCONTRACT_FILTER";

export interface IGroupContractLoadByGroupIdAction {
    type: "ACTION_GROUPCONTRACT_LOAD_BY_GROUP_ID";
    groupId: number;
}

export interface IGroupContractLoadByGroupIdActionCreator {
    (groupId: number): IGroupContractLoadByGroupIdAction;
}

export interface IGroupContractLoadSuccessAction {
    type: "ACTION_GROUPCONTRACT_LOAD_SUCCESS";
    formData: Dtos.GroupContract | Dtos.GroupContract[];
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
    responseStatus: Dtos.ResponseStatus;
}

export interface IGroupContractLoadSuccessActionCreator {
    (
        formData: Dtos.GroupContract | Dtos.GroupContract[],
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[],
        responseStatus: Dtos.ResponseStatus
    ): IGroupContractLoadSuccessAction;
}

export interface IGroupContractLoadFailureAction {
    type: "ACTION_GROUPCONTRACT_LOAD_FAILURE";
    responseStatus: Dtos.ResponseStatus;
}

export interface IGroupContractLoadFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IGroupContractLoadFailureAction;
}

export interface IGroupContractLoadByIdAction {
    type: "ACTION_GROUPCONTRACT_LOAD_BY_ID";
    id: number;
}

export interface IGroupContractLoadByIdActionCreator {
    (id: number): IGroupContractLoadByIdAction;
}

export interface IGroupContractSaveAction {
    type: "ACTION_GROUPCONTRACT_SAVE";
    formData: Dtos.GroupContract;

}

export interface IGroupContractSaveActionCreator {
    (
        formData: Dtos.GroupContract
    ): IGroupContractSaveAction;
}

export interface IGroupContractSaveSuccessAction {
    type: "ACTION_GROUPCONTRACT_SAVE_SUCCESS";
    formData: Dtos.GroupContract;
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus;
}

export interface IGroupContractSaveSuccessActionCreator {
    (
        formData: Dtos.GroupContract,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): IGroupContractSaveSuccessAction;
}

export interface IGroupContractSaveFailureAction {
    type: "ACTION_GROUPCONTRACT_SAVE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface IGroupContractSaveFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IGroupContractSaveFailureAction;
}

export interface IGroupContractValidateAction {
    type: "ACTION_GROUPCONTRACT_VALIDATE";
    formData: Dtos.GroupContract;

}

export interface IGroupContractValidateActionCreator {
    (
        formData: Dtos.GroupContract
    ): IGroupContractValidateAction;
}

export interface IGroupContractValidateSuccessAction {
    type: "ACTION_GROUPCONTRACT_VALIDATE_SUCCESS";
    formData: Dtos.GroupContract;
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus;
}

export interface IGroupContractValidateSuccessActionCreator {
    (
        formData: Dtos.GroupContract,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): IGroupContractValidateSuccessAction;
}

export interface IGroupContractValidateFailureAction {
    type: "ACTION_GROUPCONTRACT_VALIDATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface IGroupContractValidateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IGroupContractValidateFailureAction;
}

export interface IGroupContractCreateAction {
    type: "ACTION_GROUPCONTRACT_CREATE",
    groupId: number
}

export interface IGroupContractCreateActionCreator {
    (groupId: number): IGroupContractCreateAction
}

export interface IGroupContractCreateSuccessAction {
    type: "ACTION_GROUPCONTRACT_CREATE_SUCCESS";
    formData: Dtos.GroupContract;
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
}

export interface IGroupContractCreateSuccessActionCreator {
    (
        formData: Dtos.GroupContract,
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[]
    ): IGroupContractCreateSuccessAction;
}

export interface IGroupContractCreateFailureAction {
    type: "ACTION_GROUPCONTRACT_CREATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface IGroupContractCreateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IGroupContractCreateFailureAction;
}

export interface IGroupContractClearAction {
    type: "ACTION_GROUPCONTRACT_CLEAR";
    propertiesToClear?: string[];
}

export interface IGroupContractClearActionCreator {
    (propertiesToClear?: string[]): IGroupContractClearAction;
}

export interface IGroupContractFilterActionCreator {
    (formFilter: IFormFilter): IGroupContractFilterAction;
}

export interface IGroupContractFilterAction {
    type: "ACTION_GROUPCONTRACT_FILTER";
    formFilter: IFormFilter;
}

export interface IGroupContractSyncAction {
    type: "ACTION_GROUPCONTRACT_SYNC",
    groupId: number
}

export interface IGroupContractSyncActionCreator {
    (groupId: number): IGroupContractSyncAction
}

export interface IGroupContractSyncSuccessAction {
    type: "ACTION_GROUPCONTRACT_SYNC_SUCCESS";
    formData: Dtos.GroupContract[];
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
    responseStatus: Dtos.ResponseStatus
}

export interface IGroupContractSyncSuccessActionCreator {
    (
        formData: Dtos.GroupContract[],
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[],
        responseStatus: Dtos.ResponseStatus
    ): IGroupContractSyncSuccessAction;
}

export interface IGroupContractSyncFailureAction {
    type: "ACTION_GROUPCONTRACT_SYNC_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface IGroupContractSyncFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IGroupContractSyncFailureAction;
}

export type GroupContractAction =
    IGroupContractLoadByGroupIdAction |
    IGroupContractLoadByIdAction |
    IGroupContractLoadFailureAction |
    IGroupContractLoadSuccessAction |
    IGroupContractSaveAction |
    IGroupContractSaveSuccessAction |
    IGroupContractSaveFailureAction |
    IGroupContractValidateAction |
    IGroupContractValidateSuccessAction |
    IGroupContractValidateFailureAction |
    IGroupContractCreateAction |
    IGroupContractCreateSuccessAction |
    IGroupContractCreateFailureAction |
    IGroupContractSyncAction |
    IGroupContractSyncSuccessAction |
    IGroupContractSyncFailureAction |
    IGroupContractClearAction | 
    IGroupContractFilterAction;
